
// VUE_APP_EXPRESSRUL : '"http://express.cardhobby.cn"',
// VUE_APP_USERURL : '"http://user.cardhobby.cn"',
// VUE_APP_CATEGORYURL : '"http://commodity.cardhobby.cn"',
// VUE_APP_TRANSPORT : '"http://transport.cardhobby.cn"',
// VUE_APP_WORLDURL : '"http://worldapi.cardhobby.cn"',
// VUE_APP_INTLPAY : '"http://intlpay.cardhobby.cn"',
// 
// /card ----- api
// /cms
// /commodity
// /express
// /search
// /tpush
// /transport
// /user
const gateway = process.env.VUE_APP_GATEWAY
const userinfo = gateway + '/user' //process.env.VUE_APP_USERURL
const category = gateway + '/commodity' //process.env.VUE_APP_CATEGORYURL
const worldapi = gateway + '/card' //process.env.VUE_APP_WORLDURL
const loadBalancer = (process.env.NODE_ENV == 'production' ? gateway + '/score' : process.env.VUE_APP_LOADBALANCER);//process.env.VUE_APP_WORLDURL
const solr = gateway + '/solr'//process.env.VUE_APP_SOLRURL
const intlpay = process.env.VUE_APP_INTLPAY
const intlpaypal =gateway +  (process.env.NODE_ENV == 'production' ? '/newpaypal' : '/paypal') //process.env.VUE_APP_INTLPAYPAL
const mpay = process.env.VUE_APP_MPAY
const storepay = process.env.VUE_APP_STOREPAY
const antpay = process.env.VUE_APP_ANTPAY
const dreamopay = gateway + '/dreamopay'
const express = gateway + '/express' //process.env.VUE_APP_EXPRESSRUL
const transport = gateway + '/transport' //process.env.VUE_APP_TRANSPORT
const cms = gateway + '/cms' //process.env.VUE_APP_CMS
const store = process.env.VUE_APP_STORE
const search = gateway + '/search'
const sale = gateway + '/sale'
const subscribe = gateway + '/subscribe'//process.env.VUE_APP_SEARCH
const invoice = gateway + '/invoice'//process.env.VUE_APP_INVOICE
const activity = gateway + '/activity'//process.env.VUE_APP_ACTIVIE
const attention = gateway + '/attention'//process.env.VUE_APP_ATTENTION
const payoneer = process.env.VUE_APP_PAYONEER
const kyc = (process.env.NODE_ENV == 'production' ? gateway + '/kyc' : process.env.VUE_APP_KYC) //新手认证 
// 谷歌客户端ID
// const googleClientId='1083791508914-0hjneuebo96q09vsmom4k49psabiovg2.apps.googleusercontent.com'
// 谷歌客户端密钥
//const googleClientKey='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'
//console.log(kyc)

import vaultApi from './api/vault' //vault接口

const Interface = {
  info: {
    lag: 'en', //en英文 zh 中文
    device: 'Web',
    version: 1,
    appname: 'Card Hobby',
    userinfo: userinfo,
    category: category,
    worldapi: worldapi,
    loadBalancer: loadBalancer,
    express: express,
    transport: transport,
    cms: cms,
    subscribe: subscribe,
    search: search,
    sale: sale,
    invoice: invoice,
    activity: activity,
    store: store,
    payoneer: payoneer,
    kyc: kyc
  },
  // 第三方ID
  // client:{
  //   googleClientId:googleClientId
  // },
  //intlpay
  "pay": intlpay + "/order/pay", //网页端支付?id
  "Tpay": intlpay + "/Transport/Pay", //转运-网页支付 ?id=
  "Cpay": intlpay + "/CHP/Pay", //发布点充值-网页支付 ?Consumeid=11&memberid=3
  /* OLD paypal */
  //"paypal": intlpaypal + "/paypal/Pay",//网页端支付?id
  //"Tpaypal": intlpaypal + "/paypal/TransportPay", //转运-网页支付 ?id=
  //"Cpaypal": intlpaypal + "/paypal/chppay",//发布点充值-网页支付 ?Consumeid=11&memberid=3
  /* NEW paypal */
  "paypal": intlpaypal + "/api/Order/Pay?DeviceType=1&Source=2",//网页端支付?id
  "Tpaypal": intlpaypal + "/api/TransportOrder/Pay?DeviceType=1&Source=2", //转运-网页支付 ?id=
  "Cpaypal": intlpaypal + "/api/CHP/Pay?DeviceType=1&Source=2&Device=WEB&Version=1",//发布点充值-网页支付 ?Consumeid=11&memberid=3
  "Mpay": mpay + "/OrderPay/Pay", // mpay 网页端支付?id=
  "MTpay": mpay + "/TransportPay/Pay",//mpay 轉運訂單支付?id=
  'Storepay': storepay + '/order/pay', //官方商城stripepay 
  'antCpay': antpay + '/OrderPay/Pay', //蚂蚁金融 普通订单
  'antTpay': antpay + '/TransportPay/Pay', //蚂蚁金融 转运订单
  'antSpay': antpay + '/OfficialOrderPay/Pay', //蚂蚁金融 官方订单
  'usdt': dreamopay + '/OrderPay/Pay', //普通数字货币
  'Tusdt': dreamopay + '/TransportPay/Pay', //转运数字货币

  //payoneer
  ////?Id=国内用户Id&UserType=1个人,2企业
  'PayoneerLink': gateway + '/wallet/Registration/CreateRegistrationLink',//入驻
  'PayoneerConfig': payoneer + '/Registration/GetUserConfig',//获取用户是否开通Payoneer


  //Stripe
  'StripeConfig': userinfo + '/api/StripeWhite/GetStripeWhiteByIdForRes',//获取用户是否在Stripe白名单内


  //express
  "GetExpressInfoByShipperCode": express + "/api/SubscribeMapTrackPush/GetExpressInfoByShipperCode", //  GET 通过快递单号获取快递信息
  "GetExpressShipper": express + "/api/ExpressShipper/GetExpressShipper",//获取快递公司和编码
  // kyc 新人认证
  "CreateIDForOther": kyc + "/api/User/CreateIDForOther", //非美国用户通过ID认证
  "CreateSSNForUS": kyc + "/api/User/CreateSSNForUS", //美国用户通过SSN认证
  "QueryUserAuth": kyc + "/api/User/QueryUserAuth", // get 查询用户认证状态

  //transport 
  "GetWarehouseCount": transport + "/api/TransportOrder/GetTransportOrderCount", //  GET 通过用户id获取订单总数
  "GetWarehouseOrders": transport + "/api/TransportOrder/GetOrdersPageListByMemberId", //  GET 通过快递单号获取快递信息
  "GetCommoditiesPageList": transport + "/api/TransportCommodity/GetCommoditiesPageList", //  GET 通过用户id获取仓库商品分页列表
  "SetOrder": transport + "/api/TransportOrder/CreateOrder", //  创建转运仓订单
  "UpdateModifyOrder": transport + "/api/TransportOrder/ModifyOrderAdress", //  更新转运仓订单
  "GetOrderById": transport + "/api/TransportOrder/GetOrderById", // get 通过订单id获取详情
  "GetPostageMoney": transport + "/api/TransportOrder/GetPostageMoney", //  通过地址获取邮费
  "GetWeightList": transport + "/api/WeightPrice/GetPageList", //  get 获取重量与价格列表
  "GetAllAgency": transport + "/api/TransportCommodity/GetTransportCommodityByAreaId", //  get 获取办事处全部列表
  "GetAll": transport + "/api/Agency/GetAll", //  get 获取办事处全部列表
  "CompleteOrderById": transport + "/api/TransportOrder/CompleteOrderById", //  订单通过订单id完成交易
  "SendOrderInfoToEmail": transport + "/api/TransportOrder/SendOrderInfoToEmail", //  发送订单明细给买家
  "GetCouponByMemberId": transport + "/api/Coupon/GetCouponAllByMemberId", //  获取个人优惠券
  "OrderUseCoupon": transport + "/api/TransportOrder/OrderUseCoupon", //  post使用优惠券
  "OrderCancelUseCoupon": transport + "/api/TransportOrder/OrderCancelUseCoupon", //  post取消使用得优惠券
  "GetCouponByOrderId": transport + "/api/Coupon/GetCouponByMemberId", //  获取有效的优惠券以及当前订单使用的优惠券



  //search
  "SearchPage": subscribe + '/api/SearchManager/SearchPage', //get 分页查询
  "SetNotice": subscribe + '/api/SearchManager/SetNotice', //post 设置提醒或者不提醒
  "SearchInsert": subscribe + '/api/SearchManager/Insert', //post 添加搜索关键字
  "SearchDelete": subscribe + '/api/SearchManager/Delete', //post 删除搜索关键字
  "SearchGetSetting": subscribe + '/api/SearchSetting/GetSetting', //get 获取通知的具体的配置
  "SaveBrowseTime": subscribe + '/api/SearchManager/SaveBrowseTime', //post 保存浏览时间接口


  //userinfo
  "GetToken": userinfo + "/api/Auth/GetToken", //获取token
  "GetCodeEmail": userinfo + "/api/Member/SendEmail", //向邮箱发送验证码 注册 = 0, 邮箱修改密码 = 1 2-绑定
  "GetCode": userinfo + "/api/Member/SendTelPhoneCode", //向手机号发送验证码 类型 0-注册，1-重置密码 2-绑定
  //"Register": userinfo + "/api/Member/ForeignRegister", //国外注册  @todo 旧
  "Register": userinfo + "/api/Member/RegisterTelPhoneCode", //国外手机注册  
  //"SignIn": userinfo + "/api/Member/SignIn", //登录 @todo 旧
  "SignIn": gateway + "/user/api/Member/NewSignIn", //新登录 
  "ChangePassword": userinfo + "/api/Member/ChangePassword", //登录后修改密码
  "ResetPassword": userinfo + "/api/Member/ResetPassword", //邮箱重置密码
  "ResetPasswordPhone": userinfo + "/api/Member/ResetTelPhoneCode", //手机重置密码
  "SearchShippingAddresses": userinfo + "/api/ShippingAddress/SearchShippingAddresses", //分页获取收货地址
  "SaveAddresses": userinfo + "/api/ShippingAddress/Save", //保存收货地址
  "UpdateAddresses": userinfo + "/api/ShippingAddress/Update", //更新收货地址
  "DeleteAddresses": userinfo + "/api/ShippingAddress/Delete", //删除收货地址
  "SetDefaultAddresses": userinfo + "/api/ShippingAddress/SetDefault", //设置默认地址
  //"GetAreas": userinfo + "/api/Area/GetAreas", //获取所有区域（州） @todo  旧
  "GetAreas": userinfo + "/api/Area/GetAreasByCode", //获取所有区域
  "GetNewServiceAgreements": userinfo + "/api/ServiceAgreement/GetNewServiceAgreements", //通过类型获取国外有效合规文档
  "ChangeHeadPortrait": userinfo + "/api/Member/ChangeHeadPortrait", //买家修改头像
  "ForeignChangeLocationIcon": userinfo + "/api/Member/ForeignChangeLocationIcon", //国外修改用户所在位置图标
  "GetMemberInfo": userinfo + "/api/Member/GetMemberInfo", //get 通过用户id获取用户详情
  "GetBindAccount": userinfo + "/api/Member/BindAccount", //post 绑定手机号或者邮箱
  "GetMemberByGoogleUserId": userinfo + "/api/Member/GetMemberByGoogleUserId", //通过Google用户id获取海外用户信息
  "BindGoogleUserId": userinfo + "/api/member/BindGoogleUserId", //post 绑定google用户id
  "RegisterGoogleUserId": userinfo + "/api/Member/RegisterGoogleUserId", //post 通过google注册用户
  "CheckPending": userinfo + "/api/OrderPay/CheckPending", //检查订单支付状态
  "QueryOrderPending": intlpaypal + "/api/Payment/QueryOrderPending", //查询订单支付是否存在Pending



  //cms
  "GetAllNationIcons": cms + "/api/NationIcon/GetAllNationIcons", // get 全部国家图标地址
  "GetMarketEntryAllListByAreaId": cms + "/api/MarketEntry/GetMarketEntryAllListByAreaId", // get 通过所属区域获取全部入口
  //"GetPayChannels": cms + "/api/PayChannel/GetPayChannels", // get areaId=2 // 旧
  "GetPayChannels": cms + "/api/PayChannel/GetPayChannelsByArea", // get areaCode
  "GetAreasAll": cms + "/api/Areas/GetAreasAll", // get 跨境自定义的地址
  "GetSellerList": cms + "/api/SellerRecommend/GetSellerList", // get 获取商家推荐列表-新版
  "GetNationExpressList": cms + "/api/NationExpress/GetExpressListByNacitonCode", // get 通过区域获取配置快递
  "GetNationIconByPage": cms + "/api/NationIcon/GetNationIconByPage", // get 国家图标分页列表(卖家)

  

  //antpay
  "GetAntPayChannels": antpay + '/api/PayMethod/GetPayMethod',//蚂蚁金服 获取支付方式




  "GetAccountStatus": worldapi + "/Member/GetAccountStatus", //GET 获取买家注销申请的状态
  "GetAccountInfo": worldapi + "/Member/GetAccountInfo", //GET 获取买家账号的详细信息
  "SetAccount": worldapi + "/Member/AddOverseasAcountOff", //买家提交注销申请
  "GetSellerAccountStatus": worldapi + "/Member/GetSellerAccountStatus", //GET 获取注销卖家状态（获取卖家注销申请的状态）
  "GetSellerAccountInfo": worldapi + "/Member/GetSellerAccountInfo", //GET 判断能否注销卖家权限
  "SetSellerAccount": worldapi + "/Member/SetSellerAccount", //提交注销卖家权限（卖家提交注销申请）
  "costoken": worldapi + "/NewCommodity/gettoken",//COS Token



  //category
  "GetKeyWordSearches": category + "/api/KeyWordSearch/GetKeyWordSearches", //get 搜索关键字联想
  //"GetCategories": category + "/api/Category/GetCategories", //获取商品类目及属性 get
  "GetCategories": category + "/api/Category/GetCategoriesV1", //获取商品类目及属性 get [包含“全部”]
  'GetKeyValueByThirdCategoryId': category + '/api/Category/GetKeyValueByThirdCategoryId', //三级类目id获取属性以及对应的key-value ?thirdCategoryId=1

  //worldapi
  'SetAttention': worldapi + '/Attention/SetAttention', // 关注商品或店家 关注商品传commodityid，关注卖家传selluserid memberid为当前用户ID，usermappingid
  'GetAttentionSellerList': worldapi + '/Attention/Member', //get 获取已关注店家列表
  //solr
  'SearchCommodity': solr + '/NewCommodity/SearchCommodity', //商品收搜userId, pageIndex, pageSize, searchKey, searchJson, sort, sortType
  'SearchCommodityPost': solr + '/NewCommodity/SearchCommodityPost', //商品收搜userId, pageIndex, pageSize, searchKey, searchJson, sort, sortType

  'DetailCommodity': worldapi + '/Commodity/DetailCommodity', //GET 获取商品属性 ?id=
  "GetUserDetail": worldapi + "/Member/Detail", //获取用户信息
  "GetStoresList": worldapi + "/NewMember/GetStores", //GET 获取商铺信息列表
  "SearchMyCommodities": worldapi + "/NewMyCommodity/SearchMyCommodities", //GET 获取商铺商品列表
  "GetStoreCommodities": worldapi + "/NewMember/GetStoreCommodities", //GET 获取商铺商品列表
  "GetStoreDetail": worldapi + "/NewMember/GetStoreDetail", //GET 获取商铺详细信息
  "GetUSD": worldapi + "/NewMyCommodity/GetUSD", //GET 获取美元汇率
  "GetExchangeRate": worldapi + "/NewMyCommodity/GetExchangeRate", //GET 获取汇率 memberSource
  "AuctionCheck": worldapi + "/Auction/Check", //GET 竞拍资格校验 
  "AuctionIndex": worldapi + "/Auction/Index", //GET 竞拍首页接口
  "AddAuction": worldapi + "/Auction/AddAuction", //添加竞拍
  "AuctionPayDeposit": worldapi + "/Auction/PayDeposit", //缴纳保证金
  "IsAttention": worldapi + "/Attention/IsAttention", //是否关注卡
  "CancelAttention": worldapi + "/Attention/CancelAttention", //批量取消关注
  "IsCard": worldapi + "/NewAttention/MyAttentionCommodities",  //GET 我关注列表（新增）卡
  "UserBid": worldapi + "/NewMyCommodity/Bid", //我收到的议价 /我收到的议价 (新增)
  "ChargeBargain": worldapi + "/Commodity/ChargeBargain", //我给出的议价 /我出价列表 （新增）

   //"GetNewCommodityByCodeScore":worldapi + "/NewCommodity/GetNewCommodityByCodeScore",//根据验货报告Code获取卡的评分信息
  "GetNewCommodityByCodeScore":loadBalancer + "/api/CardInfoCheckScores/GetNewCommodityByCodeScore",//根据验货报告Code获取卡的评分信息


  //attention
  "SaveTourHistory": worldapi + "/NewTourHistory/SaveTourHistory", //保存游览记录
  "GetTourHistory": worldapi + "/NewTourHistory/GetTourHistory", //GET 获取游览记录信息 
  "DelTourHistory": worldapi + "/NewTourHistory/DelTourHistory", // 删除浏览记录
  "AddPV": attention + "/CommodityPV/AddPV", // POST 添加商品浏览量


  "AddOrder": worldapi + "/NewOrder/Add", // 添加订单 
  "UpdateOrder": worldapi + "/NewOrder/Update", // 订单更新 
  "GetOrderCheck": worldapi + "/NewOrderCheck/GetOrderCheckByOrderId", //GET 通过订单id获取订单验收详情
  "SetReceive": worldapi + "/Orders/SetReceive/",// 设置商品收货
  "SetAppraisal": worldapi + "/Orders/Appraisal/",// 添加订单评价
  "SearchBuyOrders": worldapi + "/NewOrder/SearchBuyOrders", //GET 我购买的接口
  "GetBuyStatistics": worldapi + "/NewOrder/GetBuyStatistics", //GET 买家订单统计
  "OrdersSetAddress": worldapi + "/Orders/SetAddress/", // 设置订单快递信息 / 修改订单地址
  "OrdersDetail": worldapi + "/NewOrder/Detail", //GET 新订单详情
  "GetAppraisalList": worldapi + "/NewOrder/AppraisalList", //GET 评价列表
  "GetAppraisalListByOrder": worldapi + "/NewOrder/AppraisalistByOrder", //GET 评价详情

  "GetServiceFeeByCommodityID": worldapi + "/NewOrder/GetServiceFeeByCommodityID", //GET 根据卡片id获取服务费
  "GetServiceFeeByOrderID": worldapi + "/NewOrder/GetServiceFeeByOrderID", //GET 根据订单id获取服务费
  "GetTaxPrice": worldapi + "/NewOrder/GetTaxPrice", //GET 获取税费
  "GetServiceList": worldapi + "/NewOrder/GetServiceList", //GET 用户来源对应服务费列表
  "GetTaxList": worldapi + "/NewOrder/GetTaxList", //GET 获取税费列表


  "BargainAdd": worldapi + "/Bargain/Add", //GET 添加议价消息
  "BargainList": worldapi + "/Bargain/Index", //GET 出价历史/商品议价信息

  "Approve": worldapi + "/Bargain/Approve", //POST 同意对方议价
  "BuyerAuction": worldapi + "/NewMyCommodity/BuyerAuction", //GET 买家参与的商品竞拍列表
  "BuyerBargain": worldapi + "/NewMyCommodity/BuyerBargain", //GET 买家给出的议价
  "NotificationCount": worldapi + "/Notification/NotificationCount", //GET 获取消息未读数
  "MyNotificationForWeb": worldapi + "/Notification/MyNotificationForWeb", //GET 消息二级列表_web专用
  "NotificationDetail": worldapi + "/Notification/Detail", //GET 消息详情
  "NotificationSetRead": worldapi + "/Notification/SetRead/", //标记消息已读
  "NotificationSetReads": worldapi + "/Notification/SetReads/", //批量标记消息已读
  "DeleteMessgaes": worldapi + "/Notification/DeleteMessgaes", //批量删除消息

  "GetSafeRights": worldapi + "/Orders/GetSafeRights", //获取维权的申诉列表
  "AddSafeRight": worldapi + "/Orders/AddSafeRight/", //POST 申请维权
  "UploadImage": worldapi + "/NewCommodity/UploadImage", //POST 申请维权
  "ReOpenSafeRight": worldapi + "/Orders/ReOpenSafeRight", //再次申请维权
  "CancelSafrRight": worldapi + "/Orders/CancelSafrRight", //POST 取消维权
  "AppealSafrRight": worldapi + "/Orders/AppealSafrRight", //申诉维权
  "GetPlanSRResultByOrderId": worldapi + "/Orders/GetPlanSRResultByOrderId", //获取卡淘维权预处理详情通过id
  "ModityPlanSRResultExpress": worldapi + "/Orders/ModityPlanSRResultExpress",//POST 维权预处理买家上传快递单号
  "GetSRCategoryList": worldapi + "/Orders/GetSRCategoryList",//维权选项

  //CHP
  "Consumption": worldapi + "/Consume/Index", //GET 消费明细
  "GetCHPList": worldapi + "/NewOrder/Consumption", //GET 获取发布点充值套餐
  "GetMemberCHP": worldapi + "/NewRefundCHP/GetMemberCHPByMemberId", //GET 获取用户chp
  "AddRefundCHPInfo": worldapi + "/NewRefundCHP/AddRefundCHPInfo", //POST 申请chp退款
  "GetRefundCHPList": worldapi + "/NewRefundCHP/GetRefundCHPPageByMemberId", //POST 申请chp退款
  

  "GetMemberAddress": worldapi + "/MemberAddress/GetMemberAddress", //GET 获取快递模板信息
  // "GetCartPostageMoney": worldapi + "/Orders/GetPostageMoney", //GET 获取邮费
  //"GetAdvertisement": worldapi + "/Advertisement/Index", //GET 旧获取所有的广告位
  "GetAdvertisement": gateway + "/Advert/api/Advertisement/GetAdvertisementWebList", //GET 新 获取所有的广告位
  "GetAgency": worldapi + "/NewOrder/GetAgency", //GET 根据卖家来源获取办事处信息


  // 获取提货码
  "GetAbholungCode": worldapi + "/Orders/AbholungCode",//GET 获取提货码

  //跨境订单地址操作
  "GetMemberByMemberId": worldapi + "/MemberAreas/GetMemberAreasPageByMemberId", //通过用户获取用户地址
  "GetMemberById": worldapi + "/MemberAreas/GetMemberAreasById", //通过id获取详情
  "SaveMemberAreas": worldapi + "/MemberAreas/SaveMemberAreas", //保存地址
  "SetMembeUpdateInfo": worldapi + "/MemberAreas/UpdateInfo", //修改地址
  "SetMembeDeleteInfo": worldapi + "/MemberAreas/DeleteInfo", //删除地址
  "SetMembeSetDefault": worldapi + "/MemberAreas/SetDefault", //设置默认地址
  "UpdateTransportAddress": worldapi + "/NewOrder/UpdateTransportAddress", //跨境订单修改自定义收货地址

  // 退税接口
  "GetOrderRefundTaxPage": invoice + "/api/OrderRefundTax/GetOrderRefundTaxPage", //GET 获取用户记录退税列表
  "GetOrderRefundTaxById": invoice + "/api/OrderRefundTax/GetOrderRefundTaxById", //GET 获取退税详情
  "GetRefundTaxOrderPage": invoice + "/api/OrderRefundTax/GetRefundTaxOrderPage", //GET 获取用户待退税订单列表
  "AddOrderRefundTax": invoice + "/api/OrderRefundTax/AddOrderRefundTax", // 退税申请








  //Official 官方商城接口
  "GetSearchConfig": worldapi + "/Official/GetSearchConfig",//GET 获取官方商城查询项目
  "GetyCategories": worldapi + "/Official/GetyCategories", //GET 获取官方商城商品类目
  "GetOfficePropertys": worldapi + "/Official/GetOfficePropertys", //GET 获取官方商城所有的属性
  'GetCommodities': worldapi + '/Official/GetCommodities', //get 获取官方商城的列表userId, pageIndex, pageSize, searchKey, searchJson, sort, sortType
  "GetMyCart": worldapi + "/Official/GetMyCart", //GET 获取购物车列表
  "AddCart": worldapi + "/Official/AddCart", // 添加到购物车
  "RemoveCart": worldapi + "/Official/RemoveCart", // 移除购物车商品
  "RemoveCartAll": worldapi + "/Official/RemoveCartAll", // 清空购物车
  "RemoveCartNoUse": worldapi + "/Official/RemoveCartNoUse", // 移除购物车中所有过期的商品
  "MyCoupon": worldapi + "/Official/MyCoupon", // 获取我的优惠券列表
  "GetShareCoupon": worldapi + "/Official/GetShareCoupon", // get 订单分享优惠券页面
  "DrawCoupon": worldapi + "/Official/DrawCoupon", // 领取分享的优惠券
  "GetCartPostageMoney": worldapi + "/Official/GetPostageMoney", //GET 获取邮费
  "OfficialAddOrder": worldapi + "/Official/AddOrder", // 添加订单（订单不存在新增订单，订单存在时修改订单收货地址）

  //storeapi 新官方商城
  'GetStoreToken': store + '/auth/gettoken', //获取官方商城Token
  //'GetCategoryCache':store + '/commodity/api/CardCategory/GetCategoryCache', //获取缓存类别
  'GetCategoryCache': store + '/commodity/api/CardCategory/GetCategoryCacheNew', //获取缓存类别_新版
  'GetListByPage': store + '/commodity/api/Commodity/GetListByPage', //查询商品列表
  'GetDetail': store + '/commodity/api/Commodity/GetDetailByArea', //查询商品详情
  'GetPostageById': store + '/user/api/Postage/GetPostageById', //获取具体邮费的配置
  'SetShopCart': store + '/commodity/api/ShoppingCart/Add', //添加购物车
  'GetCartList': store + '/commodity/api/ShoppingCart/GetListByPage', //获取购物车
  'RemoveShopCart': store + '/commodity/api/ShoppingCart/Remove', //删除购物车
  'GetPostageByProvinceName': store + '/user/api/Postage/GetPostageByProvinceName', //根据城市的名称获取邮费
  'getTax': store + '/order/api/TaxSetting/SearchByStateName', //获取税率详情
  'OrderCreate': store + '/order/api/Order/OrderCreate', //创建订单（买家调用）
  'OrderList': store + '/order/api/Order/OrderList', //get 获取买家的所有订单信息
  'GetMyOrderStatistics': store + '/Order/api/Order/GetMyOrderStatistics', //get 获取我的订单统计
  'UpdateStoreAddress': store + '/order/api/Order/UpdateAddress', //修改订单的地址信息（买家调用）
  'GetStoreOrderById': store + '/order/api/Order/GetById', //get 根据id获取订单信息
  'ConfirmReceipt': store + '/order/api/Order/ConfirmReceipt', //买家确认收货
  'GetExpressSubscribeInfo': store + '/express/api/ExpressSubscribe/GetExpressSubscribeInfo', //获取快递信息
  'GetConditionRecord': store + '/order/api/OrderRecord/GetConditionRecord', //get 获取某人在某个国家或者地区购买某商品的某规格的已购数量




  //activty 活动
  "CheckUserActive": userinfo + "/api/Active/CheckUserActive", //GET 判断用户是否可参与活动
  "CheckUserIsPrize": userinfo + "/api/Active/CheckUserIsPrize", //GET 判断用户是否已发放奖品


  'GetActivityToken': activity + '/api/Auth/GetToken', //获取活动Token
  "GetActivitySwitch": activity + "/api/ActivitySwitch/GetActivitySwitch",//get 活动开关配置
  "GetActivityList": activity + "/api/Activity/GetListByPage",// 查询活动列表
  "GetActivityDetail": activity + "/api/Activity/GetCacheById",// 查询活动详情
  "GetActivityOrderList": activity + "/api/Order/GetOrderListPage",//get 查询订单列表


  //黑名单
  "OperateBlacklist": worldapi + "/Member/OperateBlacklist", //加入/取消黑名单
  "MyBlacklist": worldapi + "/Member/MyBlacklist", //GET 黑名单列表
  "AttentionDetail": worldapi + "/Member/AttentionDetail", //GET 个人信息

  //在售，售出
  "OnSaleSearchCommodity": sale + "/api/SearchCommodity/SearchCommodity", //post 在售商品
  "SoldSearchCommodity": search + "/api/SearchCommodity/SearchCommodity", //post 售出商品


  //同意协议
  "GetNewDocment": worldapi + "/ServiceAgreement/GetNewDocment", //获取协议
  "SetServiceAgreementLog": worldapi + "/ServiceAgreement/SetServiceAgreementLog", //同意协议
  "UpdateServiceAgreementLog": worldapi + "/ServiceAgreement/UpdateServiceAgreementLog", //更新协议

  ...vaultApi

}
export default {
  Interface
};



// WEBPACK FOOTER //
// ./src/api/apiInterface.js